import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const NotificationsLinksLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "NotificationsLinks" */
      './NotificationsLinks.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
